import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import { isBodexEsHost } from '../../utils/analytics';
import { isBodexNoHostname, isBodexDkHostname } from '../../utils/spanishMarket';
import './Testimonials.css';

// On the Spanish-market sites the testimonials keep the same quotes (already
// translated per language) but the names are swapped to local equivalents so the
// social proof matches the visitor's market. The cities stay Spanish because the
// listings themselves are in Spain.
const ES_AUTHORS = ['Sofia, Alicante', 'Nils, Dénia', 'Pablo, Torrevieja'];
const NO_AUTHORS = ['Ingrid, Alicante', 'Espen, Dénia', 'Magnus, Torrevieja'];
const DK_AUTHORS = ['Mette, Alicante', 'Lars, Dénia', 'Anders, Torrevieja'];
// The Norwegian home market (bodex.no, excluding the /spania Spanish route) uses
// Norwegian names paired with Norwegian cities so the social proof is local.
const NO_HOME_AUTHORS = ['Ingrid, Oslo', 'Espen, Bergen', 'Magnus, Trondheim'];
const DK_HOME_AUTHORS = ['Mette, København', 'Lars, Aarhus', 'Anders, Odense'];

// Picks the market-specific author list. On bodex.no the /spania route keeps the
// Norwegian-in-Spain authors, while the Norwegian home market uses Norwegian
// cities. Falls back to the Danish and generic Spanish-market lists, and returns
// null on other domains so the default per-language testimonial authors are used.
const getMarketAuthors = () => {
  if (typeof window === 'undefined') return null;
  const hostname = (window.location.hostname || '').toLowerCase();
  if (isBodexNoHostname(hostname)) {
    return isBodexEsHost() ? NO_AUTHORS : NO_HOME_AUTHORS;
  }
  if (isBodexDkHostname(hostname)) {
    return isBodexEsHost() ? DK_AUTHORS : DK_HOME_AUTHORS;
  }
  if (isBodexEsHost()) return ES_AUTHORS;
  return null;
};

const Testimonials = () => {
  const { t, tRaw } = useLanguage();
  const testimonials = tRaw('testimonials.items') || [];
  const marketAuthors = getMarketAuthors();

  return (
    <section className="testimonials-section">
      <h2>{t('testimonials.title')}</h2>
      <div className="testimonials">
        {testimonials.map((testimonial, index) => {
          const author = marketAuthors && marketAuthors[index]
            ? marketAuthors[index]
            : testimonial.author;
          return (
            <div className="testimonial-card" key={author}>
              <p>“{testimonial.quote}”</p>
              <span>– {author}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Testimonials;
